export function returnRegexMatches(
  regexValue: string,
  selectedDatasourceMetrics: { name: string }[],
  validate: boolean = true,
) {
  return !validateRegex(regexValue) && selectedDatasourceMetrics
    ? selectedDatasourceMetrics.map((el) => {
        try {
          return validate
            ? el.name.match(new RegExp(regexValue))?.[1] !== undefined
            : el.name.match(new RegExp(regexValue))?.[1]
        } catch {
          return false
        }
      })
    : []
}
export const validateRegex = (value: string | undefined) => {
  if (!value || value.length === 0) {
    return "regex is required"
  }
  try {
    new RegExp(value)
    return false
  } catch {
    return "regex is not valid"
  }
}
